<template>
	<div id="app"></div>
</template>

<script>
	export default {
		name: 'App',
	}
</script>

<style>
</style>
